import React, { Component } from 'react';
import autobind from 'react-autobind';
import { Icon, Button, Popover } from 'antd';
import translate from 'app/translations';
import PropTypes from 'prop-types';
import AgentProfilePropType from '../AgentProfilePropType';

export default class StatusTooltip extends Component {
  constructor(props) {
    super(props);
    autobind(this);
    this.t = translate;
  }

  render() {
    const {
      constants,
    } = this.props.agentProfile;

    const {
      STATUS,
    } = constants;

    const toolTipContent = (
      <div>
        {
          STATUS
            .map(kv => (
              <div key={kv.value}>
                <div className="emphasized-text">
                  {this.t(`StatusTooltip.heading.${kv.value}`)}
                </div>
                <div>
                  {this.t(`StatusTooltip.body.${kv.value}`)}
                </div>
              </div>

            ))
        }
      </div>
    );

    return (
      <Popover content={toolTipContent} title={this.t('StatusTooltip.title')} trigger="click">
        <Button size="small" className="btn-link ant-active-blue">
          <span> {this.t('StatusTooltip.btnText')}</span>
          <Icon
            style={{ padding: 0, margin: '0 0 0 2px' }}
            type="info-circle"
          />
        </Button>
      </Popover>
    );
  }
}

StatusTooltip.propTypes = {
  agentProfile: PropTypes.shape(AgentProfilePropType).isRequired,
};


